/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createTanh } from '../../factoriesAny.js';
export var tanhDependencies = {
  typedDependencies: typedDependencies,
  createTanh: createTanh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesTanh.generated.js
// module id = 1668
// module chunks = 0